export default "__VITE_ASSET__DEtr139N__"